import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-about-background bg-top pb-20 bg-[length:130rem] h-full bg-no-repeat bg-white pt-28" }
const _hoisted_2 = { class: "mx-auto max-w-4xl" }
const _hoisted_3 = { class: "mb-6 flex flex-col gap-2" }
const _hoisted_4 = { class: "flex items-center gap-2 text-sm font-medium text-gray-500" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_6 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_7 = {
  key: 2,
  class: "grid gap-5"
}
const _hoisted_8 = { class: "flex flex-col gap-4 md:flex-row md:items-start md:justify-between" }
const _hoisted_9 = { class: "space-y-2" }
const _hoisted_10 = { class: "flex flex-wrap items-center gap-2 text-xs text-gray-600" }
const _hoisted_11 = { class: "inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-1" }
const _hoisted_12 = {
  key: 0,
  class: "inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-1"
}
const _hoisted_13 = {
  key: 1,
  class: "inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-1"
}
const _hoisted_14 = {
  key: 2,
  class: "inline-flex items-center gap-1 rounded-full bg-gray-100 px-2 py-1"
}
const _hoisted_15 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "flex flex-wrap items-center gap-3" }
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 0,
  class: "text-sm text-gray-600 mt-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarDaysIcon = _resolveComponent("CalendarDaysIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ClockIcon = _resolveComponent("ClockIcon")!
  const _component_MapPinIcon = _resolveComponent("MapPinIcon")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_TicketIcon = _resolveComponent("TicketIcon")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_CalendarDaysIcon, { class: "h-4 w-4 text-primary" }),
          _cache[0] || (_cache[0] = _createTextVNode(" Events "))
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-gray-900 text-3xl font-semibold" }, " Upcoming Events ", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-gray-600" }, " Reserve your seat at curated Nevcap gatherings. ", -1))
      ]),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Loading events... "))
        : (_ctx.events.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, " No events scheduled yet. "))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (event) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: event._id,
                  class: "bg-white border border-gray-200 shadow-sm rounded-2xl p-6"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_router_link, {
                        class: "text-gray-900 text-lg font-semibold hover:text-primary",
                        to: `/dashboard/events/${event._id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(event.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("span", _hoisted_11, [
                          _createVNode(_component_CalendarDaysIcon, { class: "h-3.5 w-3.5" }),
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDate(event.date)), 1)
                        ]),
                        (event.startTime || event.endTime)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                              _createVNode(_component_ClockIcon, { class: "h-3.5 w-3.5" }),
                              _createTextVNode(" " + _toDisplayString(_ctx.formatTimeRange(event.startTime, event.endTime)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (event.location)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                              _createVNode(_component_MapPinIcon, { class: "h-3.5 w-3.5" }),
                              _createTextVNode(" " + _toDisplayString(event.location), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (event.type)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(event.type), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        (event.hidePrice)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Paid event"))
                          : (typeof event.price === 'number')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, "£" + _toDisplayString(_ctx.formatPrice(event.price)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_18, "Free"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_router_link, {
                        class: "inline-flex items-center rounded-full border border-gray-300 px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-100",
                        to: `/dashboard/events/${event._id}`
                      }, {
                        default: _withCtx(() => [
                          _cache[3] || (_cache[3] = _createTextVNode(" View ")),
                          _createVNode(_component_ArrowRightIcon, { class: "ml-2 h-4 w-4" })
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      (event.ticketUrl)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "inline-flex items-center rounded-full bg-primary px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-[#c9ad99]",
                            href: event.ticketUrl,
                            rel: "noreferrer",
                            target: "_blank"
                          }, [
                            _createVNode(_component_TicketIcon, { class: "mr-2 h-4 w-4" }),
                            _cache[4] || (_cache[4] = _createTextVNode(" Get ticket "))
                          ], 8, _hoisted_20))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (event.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(event.description), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
    ])
  ]))
}